export default "__VITE_ASSET__DWPtNzqJ__"